var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSoundIcon = function SvgSoundIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 40.5c11.046 0 20-8.954 20-20S31.046.5 20 .5 0 9.454 0 20.5s8.954 20 20 20Z",
    fill: "#090A4A",
    fillOpacity: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.622 13.914c-.18 0-.36 0-.54.18l-4.325 4.145h-1.982c-.36 0-.54.18-.54.54v4.325c0 .36.18.54.54.54h1.982l4.324 4.144c.18.18.36.18.36 0 .36-.18.721-.54.721-.9V14.814c.18-.36-.18-.72-.54-.9ZM25.044 20.942a2 2 0 0 1-1.982 1.981V18.78c1.082 0 1.982.901 1.982 2.163Z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.64 33.194c-6.667 0-12.073-5.406-12.073-12.072 0-6.307 4.865-11.532 11.172-12.072h.9c.541 0 .901.36.901.9 0 .541-.36.901-.9.901h-.721c-5.406.36-9.55 4.865-9.55 10.27 0 5.766 4.685 10.27 10.27 10.27 5.766 0 10.27-4.684 10.27-10.27 0-3.062-1.44-5.945-3.783-7.927-.36-.36-.36-.901-.18-1.262.36-.36.9-.36 1.261-.18 2.883 2.343 4.324 5.766 4.324 9.37.18 6.666-5.225 12.072-11.891 12.072Z",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.522 9.77c-.18-.18-.18-.36-.18-.36l-3.424-3.424c-.36-.36-1.08-.36-1.441 0-.36.36-.36 1.081 0 1.442l2.702 2.702-2.882 2.523c-.541.36-.541.9-.18 1.441.18.18.36.36.72.36.18 0 .54-.18.72-.18l3.604-3.243c.36-.36.541-.72.36-1.26Z",
    fill: "#fff"
  })));
};
export default SvgSoundIcon;